import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import FormDataContext from "integrations/contexts/FormDataContext";
import fetch from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
import { ApiRoutes } from "./common/Routes";
import formValidation from "./utils/formValidation";
import FormWrap from "../common/FormWrap";
import ValidatedInput from "../common/ValidatedInput";
import handleFileUpload from "../helpers/fileReader";
const StepAuthorize = ({ onSubmit, onChange }) => {
  const { t } = useTranslation("enterprise_integrations");
  const { formData } = useContext(FormDataContext);
  const [formError, setFormError] = useState(null);
  const handleSubmit = () => {
    var _a, _b, _c;
    fetch("POST", qualifyUrl(ApiRoutes.INTEGRATIONS.Gmail.CHECK_CREDENTIALS), {
      gmail_project_id: ((_a = formData == null ? void 0 : formData.projectId) == null ? void 0 : _a.value) || "",
      gmail_client_id: ((_b = formData == null ? void 0 : formData.clientId) == null ? void 0 : _b.value) || "",
      gmail_service_account_key: ((_c = formData == null ? void 0 : formData.serviceAccountKey) == null ? void 0 : _c.fileContent) || ""
    }).then((result) => {
      if (result.result === "valid") {
        setFormError(null);
        onSubmit();
      } else {
        setFormError({
          full_message: result.result,
          nice_message: t("gmail.errors.unable_to_connect")
        });
      }
    }).catch((err) => {
      setFormError({
        full_message: err.message,
        nice_message: t("gmail.errors.unable_to_connect")
      });
    });
  };
  const onFileUpload = (e) => {
    e.persist();
    handleFileUpload(e.target.files[0], (fileName, fileContent) => onChange(e, { fileName, fileContent }));
  };
  const accountKeyHelpText = formData.serviceAccountKey && formData.serviceAccountKey.fileName ? t("gmail.authorize.currently_using_file", { fileName: formData.serviceAccountKey.fileName }) : t("gmail.authorize.service_account_key_help");
  const isFormValid = formValidation.isFormValid(["gmailName", "projectId", "clientId", "serviceAccountKey"], formData);
  return /* @__PURE__ */ React.createElement(
    FormWrap,
    {
      onSubmit: handleSubmit,
      buttonContent: t("gmail.authorize.verify_and_proceed"),
      disabled: isFormValid,
      title: "",
      error: formError,
      description: ""
    },
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        id: "gmailName",
        type: "text",
        fieldData: formData.gmailName,
        onChange,
        placeholder: t("common.fields.input_name"),
        label: t("common.fields.input_name"),
        autoComplete: "off",
        help: t("common.fields.input_name_help"),
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        id: "projectId",
        type: "text",
        fieldData: formData.projectId,
        onChange,
        label: t("gmail.authorize.project_id"),
        help: t("gmail.authorize.project_id_help"),
        autoComplete: "off",
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        id: "clientId",
        type: "text",
        onChange,
        fieldData: formData.clientId,
        help: t("gmail.authorize.client_id_help"),
        label: t("gmail.authorize.client_id"),
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        id: "serviceAccountKey",
        type: "file",
        onChange: onFileUpload,
        fieldData: formData.serviceAccountKey,
        label: t("gmail.authorize.service_account_key"),
        help: accountKeyHelpText,
        accept: ".json",
        required: true
      }
    )
  );
};
export default StepAuthorize;
